module.exports = __webpack_public_path__ + "img/04.32a15e47.jpg";